import {
  FilterBody,
  Pagination,
  ProjectFields,
  SortOption
} from '@yes.technology/react-toolkit'

const DEFAULT_PAGINATION = { limit: 10, offset: 0 }

const DEFAULT_SORT_OPTIONS: SortOption[] = [
  {
    date_creation_row: 'desc'
  }
]

type BuildFilterBodyProps = {
  hasActiveSituation?: boolean
  objectUUID?: string
  objectSID?: string
  skipRelations?: boolean
  skipMetadata?: boolean
  projectFields?: ProjectFields
  pagination?: Pagination
  orderby?: SortOption[]
  objectclassUUID: string
}

export const buildFilterBody = ({
  hasActiveSituation,
  objectUUID,
  objectSID,
  skipMetadata = false,
  skipRelations = false,
  projectFields,
  objectclassUUID,
  pagination = DEFAULT_PAGINATION,
  orderby = DEFAULT_SORT_OPTIONS
}: BuildFilterBodyProps): FilterBody => {
  const queryConditions: FilterBody['query'][''] = []

  if (hasActiveSituation) {
    queryConditions.push({
      'situation.des': {
        $gte: globalThis.activeSituationCode
      }
    })
  }

  if (objectUUID) {
    queryConditions.push({
      'uuid.des': { $eq: objectUUID }
    })
  }

  if (objectSID) {
    queryConditions.push({
      'sid.des': { $eq: objectSID }
    })
  }

  return {
    query: {
      $and: queryConditions
    },
    objectclass: objectclassUUID,
    skip_relations: skipRelations,
    skip_metadata: skipMetadata,
    project_fields: projectFields,
    pagination,
    orderby
  }
}
